<div id="content" class="main-layout mt-1 mb-1 pb-2" style="padding-top: 50px;">
  <app-loading-spinner [hidden]="  !(userProfleLoading$ | async)"></app-loading-spinner>
  @if(!(userProfleLoading$ | async)) {
  <div id="home">
    <div class="row">
      <div class="col" style="display: flex;">
        <div class="row row-cols-xl-4 row-cols-lg-3 row-cols-md-2 row-cols-1">
          <div class="col" *ngIf="isnotSupervisor$ | async">
            <app-entry-bucket [targetRoute]="pageRoutePath.DRIVER_DATA" [imagePath]="'images/open_orders.png'"
              [iconName]="'admin_panel_settings'" [label]="'ml_151039'"></app-entry-bucket>
          </div>
          <div class="col">
            <app-entry-bucket [imagePath]="'images/create_order.png'" [label]="'ml_151040'" [iconName]="'dashboard'"
              [targetRoute]="pageRoutePath.COUNTRY_LEVEL_OVERVIEW"></app-entry-bucket>
          </div>
          <div class="col">
            <app-entry-bucket [targetRoute]="pageRoutePath.COACHING" [imagePath]="'images/deliveries_and_shipment.png'"
              [label]="'ml_144058'" [iconName]="'supervisor_account'"></app-entry-bucket>
          </div>
          <div class="col">
            <app-entry-bucket [imagePath]="'images/create_new_customer.png'" [label]="'ml_151041'"
              [targetRoute]="pageRoutePath.KPI_OTHERS" [iconName]="'summarize'"></app-entry-bucket>
          </div>
          <div class="col">
            <app-entry-bucket [targetRoute]="pageRoutePath.TEAM_MESSAGE" [imagePath]="'images/stock_management.png'"
              [label]="'ml_144039'" [iconName]="'drafts'"></app-entry-bucket>
          </div>
        </div>
      </div>
    </div>
  </div>
  }
</div>